<script>
import { AppLayout, PageHeader } from '@/components/layout'
import appConfig from '@/app.config'
import tableMixin from '@/mixins/table'
import api from '@/helpers/api'
import { required, minValue, decimal } from 'vuelidate/lib/validators'
import Forms from '@/components/forms'
import { mapGetters } from 'vuex'
import { authComputed } from '@/state/helpers'

export default {
  name: 'sales.forms.list',
  mixins: [tableMixin],
  page: {
    title: 'Cart',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  props: {
    title: { type: String, default: 'My Cart' }
  },
  components: {
    AppLayout,
    PageHeader
  },
  data () {
    return {
      isLoading: false,
      search: null,
      showCustomForm: false,
      previewStlFileId: null,
      previewStl: false,
      previewStlUrl: '',
      fileLoadProgress: 0,
      selectedItem: { item: {} },
      lights: [
        {
          type: 'point',
          color: '#0095f5',
          intensity: 1
        }
      ]
    }
  },
  mounted () {
    this.onRefresh()
  },
  watch: {
    search: 'onRefresh',
    currentPage: 'onRefresh',
    perPage: 'onRefresh',
    cartCount: 'onRefresh'
  },
  methods: {
    async onStlLoadProcess (event) {
      this.fileLoadProgress = Math.floor((event.loaded / event.total) * 100)

      if (this.fileLoadProgress < 100) this.isFileLoading = true
      else this.isFileLoading = false
    },
    async onPreviewStlFile (file_id) {
      if (this.previewStl && this.previewStlFileId === file_id)
        this.previewStl = false
      else {
        this.previewStl = true

        let { url } = await api.files.download_url({
          file_id
        })
        this.previewStlUrl = url
        this.previewStlFileId = file_id
      }
    },
    async onRefresh () {
      this.isLoading = true
      const filters = [{ is_submitted: { _eq: false } }]
      if (this.userRole !== 'admin') {
        const customerAccountId =
          this.userProfile && this.userProfile.customer_account_id
        if (customerAccountId) {
          filters.push({ customer_account_id: { _eq: customerAccountId } })
        }
      }
      let { items, total_rows } = await api.webForms.fetchPage({
        page: this.currentPage,
        pageSize: this.perPage === 'All' ? -1 : this.perPage,
        needle: this.search,
        orderBy: [{ created_at: 'asc' }],
        filters
      })
      this.data = items
      this.totalRows = total_rows
      this.isLoading = false
    },
    async onClearCart () {
      let ok = await this.$bvModal.msgBoxConfirm(
        'Please confirm that you want to clear the cart.',
        {
          title: 'Please Confirm',
          size: 'md',
          okVariant: 'primary',
          cancelVariant: 'link',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }
      )

      if (ok) {
        await this.$store.dispatch('cart/clearCart')
        this.onRefresh()
      }
    },
    async onCheckoutCart () {
      let ok = await this.$bvModal.msgBoxConfirm(
        'Please confirm that you want to Checkout the cart.',
        {
          title: 'Confirm Cart Checkout',
          size: 'md',
          okVariant: 'primary',
          cancelVariant: 'link',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }
      )

      if (ok) {
        await this.$store.dispatch('cart/checkoutCart')
        this.onRefresh()
      }
    },

    async onCheckoutItem (item) {
      if (!this.canManageItem(item)) return
      let ok = await this.$bvModal.msgBoxConfirm(
        'Please confirm that you want to checkout this item.',
        {
          title: 'Confirm Item Checkout',
          size: 'md',
          okVariant: 'primary',
          cancelVariant: 'link',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }
      )

      if (ok) {
        await this.$store.dispatch('cart/checkoutItem', { item })
        this.onRefresh()
      }
    },
    onEditHandler (item) {
      if (!this.canManageItem(item)) return
      const {
        reference,
        file_id,
        item_id,
        form_data = {},
        comments,
        shipping_address_id,
        customer_account_id
      } = item
      if (customer_account_id) {
        this.$store.commit(
          'auth/SET_SELECTED_CUSTOMER_ACCOUNT_ID',
          customer_account_id
        )
      }
      this.selectedItem = {
        ...item,
        specifications: {
          images: item.web_form_files,
          reference,
          file_id,
          item_id,
          comments,
          customer_account_id,
          enable_shipping: shipping_address_id ? 'yes' : 'no',
          shipping_address_id,
          specs: form_data
        }
      }
      this.showCustomForm = true
    },
    async onRemoveHandler (item) {
      if (!this.canManageItem(item)) return
      let ok = await this.$bvModal.msgBoxConfirm(
        'Please confirm that you want to delete this Item.',
        {
          title: 'Please Confirm',
          size: 'md',
          okVariant: 'primary',
          cancelVariant: 'link',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }
      )

      if (ok) {
        await this.$store.dispatch('cart/removeFromCart', {
          id: item.id,
          file_id: item.file_id
        })
        this.onRefresh()
      }
    },
    async onQuantityUpdated (item) {
      if (!this.canManageItem(item)) return
      if (!this.$v.$invalid) {
        await this.$store.dispatch('cart/updateCartItem', {
          data: { ...item },
          id: item.id
        })
        this.$bvToast.toast(
          `Quantity for ${item.item.short_description} (ref. ${item.reference}) was updated!`,
          {
            title: 'Quantity updated',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'success',
            autoHideDelay: 1000,
            appendToast: true
          }
        )
      } else {
        this.$bvToast.toast(`Quantity must must be greater than zero!`, {
          title: 'Error',
          solid: true,
          toaster: 'b-toaster-top-center',
          variant: 'danger',
          autoHideDelay: 1000,
          appendToast: true
        })
        item.quantity = 1
      }
    },
    async onCustomFormComplete (item) {
      const {
        reference,
        file_id,
        enable_shipping,
        shipping_address_id,
        comments,
        images,
        specs = {},
        customer_account_id
      } = item

      const { id } = this.selectedItem

      await this.$store.dispatch('cart/updateCartItem', {
        data: {
          reference,
          file_id,
          shipping_address_id: enable_shipping ? shipping_address_id : null,
          comments,
          form_data: specs,
          ...(customer_account_id ? { customer_account_id } : {})
        },
        web_form_files: images,
        id
      })
      this.$bvToast.toast(
        `${this.selectedItem.item.short_description} was updated!`,
        {
          title: 'Quantity updated',
          solid: true,
          toaster: 'b-toaster-top-center',
          variant: 'success',
          autoHideDelay: 1000,
          appendToast: true
        }
      )
      this.onRefresh()
      this.selectedItem = { item: {} }
      this.showCustomForm = false
    },
    onStlError (error) {
      console.error(error)
    },
    referenceOf (item) {
      return item.reference || this.$t('no reference')
    },
    itemOf (item) {
      return (item.item && item.item.short_description) || this.$t('my_orders.dash')
    },
    modelOf (item) {
      if (!item.form_data || !item.form_data.model_type) return null
      return this.$t(`attribute.model_type.${item.form_data.model_type}`)
    },
    foamOf (item) {
      if (!item.form_data || !item.form_data.foam_type) return null
      return this.$t(`attribute.foam_type_short.${item.form_data.foam_type}`)
    },
    isMixFoam (item) {
      return !!(item.form_data && item.form_data.foam_type === 'mix')
    },
    isRemill (item) {
      return !!(item.form_data && item.form_data.is_remill)
    },
    companyOf (item) {
      return (
        (item.customer && item.customer.company_name) ||
        this.$t('my_orders.dash')
      )
    },
    shippingOf (item) {
      if (item.shipping_address) {
        return `${item.shipping_address.company_name}, ${item.shipping_address.city}`
      }
      return this.$t('no shipping')
    },
    canManageItem (item) {
      if (!this.isAdmin) return true
      const currentUserId = this.currentUser && this.currentUser.id
      return !!currentUserId && item.user_id === currentUserId
    }
  },
  computed: {
    ...authComputed,
    ...mapGetters('cart', ['cartCount']),
    isAdmin () {
      return this.userRole === 'admin'
    },
    customForm () {
      const { webshop_custom_form } = this.selectedItem.item
      if (
        Object.prototype.hasOwnProperty.call(Forms, webshop_custom_form) &&
        Forms[webshop_custom_form].component
      )
        return Forms[webshop_custom_form].component
      return null
    },
    breadcrumbs () {
      return [
        {
          text: 'Cart',
          active: true
        }
      ]
    }
  },
  validations () {
    return {
      data: {
        $each: {
          quantity: {
            required,
            decimal,
            minValue: minValue(1)
          }
        }
      }
    }
  }
}
</script>

<template>
  <AppLayout>
    <PageHeader :title="$t(title)" :items="breadcrumbs" />

    <div class="portal-orders">
      <div class="portal-card portal-card--panel">
        <div class="portal-orders__header">
          <div>
            <div class="portal-card__eyebrow mb-1">
              {{ $t('cart.eyebrow') }}
            </div>
            <div class="portal-card__panel-title">{{ $t('cart.subtitle') }}</div>
          </div>

          <div class="portal-orders__toolbar">
            <g-search-input
              v-model="search"
              :placeholder="$t('cart.search_placeholder')"
              width="260px"
              class="portal-orders__search"
            />
            <b-btn
              variant="link"
              size="sm"
              class="p-0 portal-orders__refresh"
              @click="onRefresh"
            >
              <i class="fas fa-sync"></i>
            </b-btn>
            <template v-if="!isAdmin">
              <b-btn
                variant="link"
                size="sm"
                class="p-0"
                :disabled="data.length === 0"
                @click="onClearCart"
              >
                {{ $t('cart.clear') }}
              </b-btn>
              <b-btn
                variant="primary"
                class="btn-label"
                :disabled="data.length === 0"
                @click="onCheckoutCart"
              >
                <i class="bx bx-mail-send label-icon"></i>{{ $t('cart.checkout') }}
              </b-btn>
            </template>
          </div>
        </div>

        <div v-if="isLoading" class="text-muted small py-4">
          {{ $t('Loading...') }}
        </div>

        <div v-else-if="!data.length" class="text-muted small py-4">
          {{ $t('cart.empty') }}
        </div>

        <div v-else class="order-table-wrap">
          <div
            class="order-table"
            role="table"
          >
            <div class="order-table__head" role="row">
              <div class="order-table__col order-table__col--date" role="columnheader">
                {{ $t('my_orders.col.date') }}
              </div>
              <div class="order-table__col order-table__col--reference" role="columnheader">
                {{ $t('my_orders.col.reference') }}
              </div>
              <div class="order-table__col order-table__col--item" role="columnheader">
                {{ $t('my_orders.col.item') }}
              </div>
              <div class="order-table__col order-table__col--shipping" role="columnheader">
                {{ $t('my_orders.col.shipping') }}
              </div>
              <div class="order-table__col order-table__col--qty" role="columnheader">
                {{ $t('my_orders.col.qty') }}
              </div>
              <div class="order-table__col order-table__col--action" role="columnheader"></div>
            </div>

            <div
              v-for="item in data"
              :key="item.id"
              class="order-table__row"
              role="row"
            >
              <div class="order-table__col order-table__col--date" role="cell" data-label="Date">
                <span class="order-table__primary">
                  {{ item.created_at | moment('DD MMM YYYY') }}
                </span>
              </div>

              <div
                class="order-table__col order-table__col--reference"
                role="cell"
                data-label="Reference"
              >
                <div class="order-table__ref">
                  <span class="order-table__primary">{{ referenceOf(item) }}</span>
                  <span
                    v-if="isRemill(item)"
                    class="order-table__flag"
                    :title="$t('Remill')"
                  >
                    <i class="mdi mdi-alpha-r-box"></i>
                  </span>
                  <span
                    v-if="item.file"
                    class="order-table__flag"
                    :title="item.file.file_name"
                  >
                    <i class="mdi mdi-file-check-outline"></i>
                  </span>
                  <button
                    v-if="isAdmin && item.file"
                    type="button"
                    class="order-table__flag-btn"
                    :title="$t('file')"
                    @click="onPreviewStlFile(item.file_id)"
                  >
                    <i class="mdi mdi-file-eye"></i>
                  </button>
                </div>
              </div>

              <div class="order-table__col order-table__col--item" role="cell" data-label="Item">
                <div class="order-table__item">
                  <span class="order-table__primary">{{ itemOf(item) }}</span>
                  <div class="order-table__item-meta">
                    <span v-if="modelOf(item)" class="order-table__muted">{{
                      modelOf(item)
                    }}</span>
                    <span
                      v-if="foamOf(item)"
                      :id="`ttFoamType${item.id}`"
                      class="order-table__foam"
                      :class="{ 'order-table__foam--mix': isMixFoam(item) }"
                    >{{ foamOf(item) }}</span>
                    <b-tooltip
                      v-if="isMixFoam(item)"
                      :target="`ttFoamType${item.id}`"
                      variant="dark"
                      placement="top"
                      container="body"
                      custom-class="text-left"
                    >
                      <p class="mx-2 my-0">
                        {{ $t('Seat') }}:
                        {{
                          $t(
                            `attribute.foam_type.${item.form_data.mix_seat_foam_type}`
                          )
                        }}<br />
                        {{ $t('Back') }}:
                        {{
                          $t(
                            `attribute.foam_type.${item.form_data.mix_back_foam_type}`
                          )
                        }}
                      </p>
                    </b-tooltip>
                  </div>
                </div>
              </div>

              <div
                class="order-table__col order-table__col--shipping"
                role="cell"
                :data-label="
                  isAdmin ? $t('my_orders.col.company') : $t('my_orders.col.shipping')
                "
              >
                <div v-if="isAdmin" class="order-table__stack">
                  <span class="order-table__primary">{{ companyOf(item) }}</span>
                  <span class="order-table__muted">{{ shippingOf(item) }}</span>
                </div>
                <span v-else class="order-table__muted">{{ shippingOf(item) }}</span>
              </div>

              <div class="order-table__col order-table__col--qty" role="cell" data-label="Qty">
                <b-form-input
                  v-model.number="item.quantity"
                  class="order-table__qty-input"
                  size="sm"
                  :readonly="!canManageItem(item)"
                  @focus="canManageItem(item) && $event.target.select()"
                  @change="onQuantityUpdated(item)"
                />
              </div>

              <div class="order-table__col order-table__col--action" role="cell">
                <div v-if="canManageItem(item)" class="order-table__actions">
                  <button
                    v-if="item.item && item.item.webshop_custom_form"
                    type="button"
                    class="order-table__icon-btn"
                    @click="onEditHandler(item)"
                  >
                    <i class="bx bx-edit"></i>
                  </button>
                  <button
                    type="button"
                    class="order-table__icon-btn order-table__icon-btn--danger"
                    @click="onRemoveHandler(item)"
                  >
                    <i class="bx bx-trash"></i>
                  </button>
                  <button
                    type="button"
                    class="order-table__icon-btn"
                    @click="onCheckoutItem(item)"
                  >
                    <i class="bx bx-mail-send"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="totalRows > minPerPage || (perPage !== 'All' && totalRows > perPage)"
          class="portal-orders__footer"
        >
          <div class="portal-orders__page-size" v-if="totalRows > minPerPage">
            <label class="d-flex align-items-center m-0">
              {{ $t('my_orders.show') }}
              <b-form-select
                v-model="perPage"
                size="sm"
                :options="pageOptions"
                class="mx-2"
              ></b-form-select>
            </label>
          </div>

          <b-pagination
            v-if="perPage !== 'All' && totalRows > perPage"
            class="pagination mb-0 justify-content-end"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            size="sm"
          >
            <template v-slot:page="{ page, active }">
              <b v-if="active">{{ page }}</b>
              <i v-else>{{ page }}</i>
            </template>
          </b-pagination>
        </div>
      </div>
    </div>

    <b-modal
      v-model="previewStl"
      centered
      size="lg"
      hide-footer
      hide-header
      static
      body-class="p-2"
    >
      <h6
        class="px-3 py-2 pb-3mb-1 font-weight-light border-bottom border-light"
      >
        Preview STL
      </h6>
      <vue3dLoader
        :key="previewStlFileId"
        :filePath="previewStlUrl"
        fileType="stl"
        :enableAxesHelper="true"
        :axesHelperSize="500"
        :enableDamping="true"
        :dampingFactor="0.05"
        :height="450"
        :lights="lights"
        :controlsOptions="{
          enablePan: false,
          enableZoom: false
        }"
        :pointLightFollowCamera="true"
        backgroundColor="#FFFFFF"
        @process="onStlLoadProcess"
        @error="onStlError"
        class="p-0 m-0"
      />
      <b-progress
        v-show="fileLoadProgress < 100"
        :value="fileLoadProgress"
        height="2px"
      ></b-progress>
    </b-modal>

    <b-modal
      v-model="showCustomForm"
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      size="lg"
      hide-footer
      hide-header
      body-class="p-2"
    >
      <h6
        class="px-3 py-2 pb-3mb-1 font-weight-light border-bottom border-light"
      >
        {{ selectedItem.item.short_description }}
      </h6>
      <component
        :is="customForm"
        :submit-label="$t('save changes')"
        submit-icon="bx bx-save"
        v-model="selectedItem.specifications"
        v-on:complete="onCustomFormComplete"
        v-on:cancel="showCustomForm = false"
        v-if="showCustomForm"
      />
    </b-modal>
  </AppLayout>
</template>

<style lang="scss" scoped>
.portal-orders {
  margin-bottom: 1.5rem;
}

.portal-card--panel {
  background: #fff;
  border-radius: 1rem;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);
  padding: 1.15rem 1.25rem;
}

.portal-card__eyebrow {
  color: #94a3b8;
  font-size: 0.8rem;
  font-weight: 500;
}

.portal-card__panel-title {
  color: #0f172a;
  font-size: 1.05rem;
  font-weight: 600;
}

.portal-orders__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.portal-orders__toolbar {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.portal-orders__search {
  margin-right: 0.75rem;
}

.portal-orders__refresh {
  color: #64748b;
}

.order-table-wrap {
  overflow-x: auto;
  margin: 0 -0.15rem;
}

.order-table {
  min-width: 780px;
}

.order-table__head,
.order-table__row {
  display: grid;
  grid-template-columns:
    7.5rem
    minmax(8.5rem, 1.1fr)
    minmax(12rem, 1.8fr)
    minmax(8rem, 1.2fr)
    4.75rem
    6.75rem;
  gap: 0.75rem;
  align-items: center;
  padding: 0.75rem 0.15rem;
}

.order-table__head {
  border-bottom: 1px solid #eef2f7;
  color: #94a3b8;
  font-size: 0.72rem;
  font-weight: 500;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.order-table__row {
  width: 100%;
  border-bottom: 1px solid #eef2f7;

  &:last-child {
    border-bottom: 0;
  }
}

.order-table__primary {
  color: #0f172a;
  font-size: 0.88rem;
  font-weight: 500;
}

.order-table__muted {
  color: #64748b;
  font-size: 0.84rem;
}

.order-table__foam {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 3.25rem;
  padding: 0.15rem 0.4rem;
  border-radius: 0.4rem;
  background: #f1f5f9;
  color: #0f172a;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.order-table__foam--mix {
  cursor: help;
}

.order-table__item {
  min-width: 0;
}

.order-table__stack {
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 0.15rem;
}

.order-table__item-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.4rem;
  margin-top: 0.2rem;
}

.order-table__ref {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  min-width: 0;
}

.order-table__flag {
  color: #556ee6;
  font-size: 1rem;
  line-height: 1;
  flex: 0 0 auto;
}

.order-table__flag-btn {
  appearance: none;
  border: 0;
  background: transparent;
  color: #556ee6;
  font-size: 1rem;
  line-height: 1;
  padding: 0;
  cursor: pointer;
}

.order-table__col--qty {
  text-align: center;
}

.order-table__qty-input {
  max-width: 3.25rem;
  margin: 0 auto;
  text-align: center;
  padding-left: 0.25rem;
  padding-right: 0.25rem;

  &[readonly] {
    background: #f8fafc;
    color: #64748b;
    pointer-events: none;
  }
}

.order-table__col--action {
  display: flex;
  justify-content: flex-end;
}

.order-table__actions {
  display: inline-flex;
  align-items: center;
  gap: 0.15rem;
}

.order-table__icon-btn {
  appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.85rem;
  height: 1.85rem;
  border: 0;
  border-radius: 0.5rem;
  background: #f1f5f9;
  color: #0f172a;
  cursor: pointer;

  &:hover {
    background: #e2e8f0;
  }

  i {
    font-size: 1rem;
  }
}

.order-table__icon-btn--danger {
  color: #f46a6a;
}

.portal-orders__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  margin-top: 1rem;
  padding-top: 0.85rem;
  border-top: 1px solid #eef2f7;
}

.portal-orders__page-size {
  color: #64748b;
  font-size: 0.85rem;
}

@media (max-width: 991.98px) {
  .order-table {
    min-width: 0;
  }

  .order-table__head {
    display: none;
  }

  .order-table__row {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 0.35rem 0.75rem;
    padding: 0.95rem 0.15rem;
  }

  .order-table__col {
    display: none;
  }

  .order-table__col--reference,
  .order-table__col--item,
  .order-table__col--date,
  .order-table__col--shipping,
  .order-table__col--qty {
    display: block;
    grid-column: 1;
  }

  .order-table__col--action {
    display: flex;
    grid-column: 2;
    grid-row: 1 / span 2;
    align-items: flex-start;
  }

  .order-table__col--reference .order-table__primary {
    font-size: 0.95rem;
  }

  .order-table__col--item::before,
  .order-table__col--date::before,
  .order-table__col--shipping::before,
  .order-table__col--qty::before {
    content: attr(data-label);
    display: inline-block;
    min-width: 4.5rem;
    margin-right: 0.35rem;
    color: #94a3b8;
    font-size: 0.72rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }

  .order-table__col--item::before {
    vertical-align: top;
    margin-top: 0.15rem;
  }

  .order-table__col--item .order-table__item {
    display: inline-block;
    vertical-align: top;
  }

  .order-table__col--qty {
    text-align: left;
  }

  .order-table__qty-input {
    margin: 0;
  }
}
</style>
